(function () {
  var methods = ['identify', 'register', 'track'];
  var metrics = {};

  function getCurrentOpal() {
    var opal;

    if (!window.AppBase) return null;

    opal = window.AppBase.request('opals:get_current_opal');
    return opal;
  }

  function getCurrentUser() {
    var opal;

    if (!window.AppBase) return null;

    opal = window.AppBase.request('users:get_current_user');
    return opal;
  }

  function getUserSegments() {
    var user = getCurrentUser();
    if (user.get('user_profile') && user.get('user_profile').get('segments')) {
      return user.get('user_profile').get('segments');
    } else {
      return [];
    }
  }

  function getFeatureFlags() {
    return Object.entries(feature_flags)
      .filter(([_, value]) => value === true)
      .map(([key]) => key)
      .join(',');
  }

  function isLabsAccount() {
    return getCurrentUser().get('user_profile').isLabsAccount();
  }

  function getCurrentPendoUserUuid() {
    var user = getCurrentUser();
    if (!user) return;

    var id = user.get('uuid');

    if (isLabsAccount()) {
      return "internal-" + id;
    }

    return id;
  }

  function getCurrentWorkspace() {
    var state = window.OpalMoments && window.OpalMoments.State;
    if (!state) return null;

    var workspace;

    try {
      workspace = state.current_brand;
    } catch (e) {}
    if (workspace) return workspace;

    try {
      workspace = OpalMoments.Collections.brands.get(state.settings.get('current_brand_id'));
    } catch (e) {}
    return workspace;
  }

  function updateIntercomConfig() {
    var user = getCurrentUser()
    var opalId;
    var opalUuid;
    var opalStatus;
    var opal = getCurrentOpal();

    if (opal) {
      opalId = opal.get('id');
      opalUuid = opal.get('uuid');
      opalStatus = opal.get('status');
    }

    if (user) {
      var email = user.get('email') || user.get('user_profile').get('email');
      var intercomSettings = {
        user_id: user.get('uuid'),
        userUuid: user.get('uuid'),
        opalUserId: user.id,
        opalId: opalId,
        opalPlan: getOpalPlan(opal),
        opalUuid: opalUuid,
        opalStatus: opalStatus,
        opalType: getOpalType(),
        isActive: true,
        roleName: Opal.State.this_user_role,
        segment1: getUserSegments()[0],
        segment2: getUserSegments()[1],
        email: email,
        name: user.get('full_name'),
        app_id: "hv1psobs",
        hide_default_launcher: true,
        custom_launcher_selector: ".kuiper-intercom-button",
        creationDate: user.get('created_at'),
        opalVersion: window.OPAL_SERVER_APPLICATION_VERSION || 'unknown'
      }
      window.intercomSettings = intercomSettings;
    }
  }

  // `AppBase.data` may not be set up when this file is parsed.
  function getShortname() {
    try {
      return window.AppBase.data.global_config.analytics_shortname;
    } catch(e) {
      return undefined;
    }
  }
  function getOpalType() {
    var shortname = getShortname();
    if (!shortname) return;
    if (shortname === 'teams') {
      return "standard";
    } else {
      return "enterprise";
    }
  };
  function getOpalPlan(opal) {
    if (!opal.get("plan")) return "enterprise";
    return opal.get("plan").system_name;
  };
  function getDistinctOpalId(opal) {
    if (!opal) return;

    return 'opal-' + opal.attributes.uuid;
  }
  function getDistinctWorkspaceId(workspace) {
    if (!workspace) return;

    return 'workspace-' + workspace.attributes.uuid;
  }

function updatePendoConfig(pendoInstance) {
    if (!pendoInstance) return;

    var options = {};

    var user = getCurrentUser()

    if (user) {
      var email = user.get('email') || user.get('user_profile').get('email');
      options.visitor = {
        id: getCurrentPendoUserUuid(),
        uuid: user.get('uuid'),
        opalUserId: user.id,
        isActive: true,
        roleName: Opal.State.this_user_role,
        segment1: getUserSegments()[0],
        segment2: getUserSegments()[1],
        email: email,
        name: user.get('full_name'),
        creationDate: user.get('created_at'),
        opalVersion: window.OPAL_SERVER_APPLICATION_VERSION || 'unknown',
      };
    }

    var workspace = getCurrentWorkspace();
    if (workspace) {
      options.account = {
        id: getDistinctWorkspaceId(workspace),
        name: getCurrentWorkspace().get('name'),
      };
    } else {
      delete options.account;
    }

    var opal = getCurrentOpal();
    var featureFlags = getFeatureFlags();

    if (opal) {
      parentAccountAttrs = {
        opalFeatureFlags: featureFlags,
        opalUuid: opal.get('uuid'),
        opalName: opal.get('name'),
        opalPlan: getOpalPlan(opal),
        opalStatus: opal.get('status'),
        opalType: getOpalType(),
      };

      if (!options.account) {
        options.account = {}
      }

      Object.assign(options.account, parentAccountAttrs);
    }

    // The Pendo instance is now created and intiailized by the /clients/web
    // codebase, but this file currently has more data available. For Monolith
    // pages, we will check if Pendo is already initialized, and update the options
    // if so. The `initialize` call is here for safety, and shouldn't ever
    // be called in actuality.
    if (typeof pendoInstance.isReady === 'function' && pendoInstance.isReady()) {
      pendoInstance.updateOptions(options);
    } else {
      pendoInstance.initialize(options);
    }
  }

  methods.forEach(function (method) {
    // `.register` sets event super properties; `.people.set` sets people
    // properties.
    var callback;
    if (method === 'register') {
      var user = getCurrentUser();

      if (user) {
        updatePendoConfig(window.pendo);
      }
    } else {
      callback = function () {};
    }

    metrics[method] = function () {
      var cleanArguments = [].slice.call(arguments);

      try {
        if (callback) {
          callback.apply(window, cleanArguments);
        }
      } catch (e) {
        window.trackJs.track(e);
      }
    };
  });

  metrics.opalTrack = function (event, inMetadata) {
    var metaData = inMetadata || {};
    metaData.sessionID = window.userAnalytics.sessionID
      || window.CREATOR_GUID
      || window.generateUUID();
    var workspace = getCurrentWorkspace();
    if (workspace) metaData.Workspace = workspace.get('name');

    metrics.track(event, metaData);

    if (getCurrentUser()) {
      updatePendoConfig(window.pendo);
      updateIntercomConfig();
    }
  };
  window.metrics = metrics;

}());
